import { Component, inject } from '@angular/core';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-launchpad-modal',
  standalone: true,
  templateUrl: './launchpad-modal.component.html'
})
export class LaunchpadModalComponent {
  public state = inject(AppStateService);
}
